import React from "react"
import Box from "@material-ui/core/Box"
import Button from "@material-ui/core/Button"
import IconSparcaComplete from "@/assets/icons/IconSparcaComplete"
import { makeStyles } from "@material-ui/core/styles"

const useStyles = makeStyles((theme) => ({
    controlPanelSidebarCompleteButton: {
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(4),
    },
    controlPanelSidebarFormIcon: {
        marginRight: theme.spacing(2),
    },
}))

const ProjectSubmit = (props) => {
    const { handleModalCompleteProjectShowChange } = props
    const classes = useStyles()

    return (
        <>
            <Box>
                <Button
                    variant="contained"
                    color="primary"
                    aria-label="complete"
                    className={classes.controlPanelSidebarCompleteButton}
                    fullWidth
                    onClick={() => handleModalCompleteProjectShowChange(true)}
                >
                    <IconSparcaComplete width="25" fill="white" className={classes.controlPanelSidebarFormIcon} />
                    Complete Project
                </Button>
            </Box>
        </>
    )
}

export default ProjectSubmit
